export type RunPeriod = 'NOT_CHOSEN_YET' | 'ONDEMAND' | 'ONCE' | 'DAILY' | 'WEEKLY' | 'MONTHLY' | 'QUATERLY' | 'YEARLY';

export const RunPeriodLabels: { [x in RunPeriod]: string } = {
  NOT_CHOSEN_YET: '',
  ONCE: '1回のみ',
  ONDEMAND: '随時',
  DAILY: '毎日',
  WEEKLY: '毎週',
  MONTHLY: '毎月',
  QUATERLY: '四半期ごと',
  YEARLY: '毎年'
};

export const RunPeriodKeys: { [runPeriod in RunPeriod]: runPeriod } = {
  NOT_CHOSEN_YET: 'NOT_CHOSEN_YET',
  ONCE: 'ONCE',
  ONDEMAND: 'ONDEMAND',
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
  QUATERLY: 'QUATERLY',
  YEARLY: 'YEARLY'
};
